/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentSubmissions.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Submissions API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Archetact ]
 *  
 *  Created:    Saturday, August 27, 2022 - 09:05:11 PM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      08/27/2022  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2022 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const Submissions = {
  all: () => requests.postLambda('/miiSubmissions', {
    "action": "getSubmissions",
    "parameters": {
      "companyid": 10000,
    },
  }),
  get: (submissionid) => requests.postLambda(`/miiSubmissions`, {
    "action": "getSubmission",
    "parameters": {
      "companyid": 10000,
      "submissionid": submissionid,
    },
  }),
  create: (submission) => requests.postLambda(`/miiSubmissions`, {
    "action": "createSubmission",
    "parameters": {
      "companyid": 10000,
      "form": submission.form,
      "fullname": submission.fullname,
      "email": submission.email,
      "message": submission.message,
      "ipaddress": submission.ipaddress,
    },
  }),
  update: (submissionid, submission) => requests.postLambda(`/miiSubmissions`, {
    "action": "editSubmission",
    "parameters": {
      "companyid": 10000,
      "submissionid": submissionid,
      "form": submission.form,
      "fullname": submission.fullname,
      "email": submission.email,
      "message": submission.message,
      "ipaddress": submission.ipaddress,
    },
  }),
  delete: (submissionid) => requests.postLambda(`/miiSubmissions`, {
    "action": "deleteSubmission",
    "parameters": {
      "companyid": 10000,
      "submissionid": submissionid,
    },
  }),
};